import React, { useState, useEffect } from 'react';
import { useOAuth } from '../../context/OAuthContext';
import { oauthAPI } from '../../services/api';
import '../admin/AdminComponents.css';

const DebugLogin = ({ onLoginSuccess }) => {
  const { handleOAuthCallback } = useOAuth();
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedCharacterId, setSelectedCharacterId] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const response = await oauthAPI.getDebugUsers();
      if (response.success) {
        setUsers(response.data || []);
      } else {
        setError('Failed to load users');
      }
    } catch (err) {
      setError(err.message || 'Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    setSelectedCharacterId('');
    setError('');
  };

  const handleCharacterSelect = (characterId) => {
    setSelectedCharacterId(characterId);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUserId) {
      setError('Please select a user');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const response = await oauthAPI.debugLogin(
        parseInt(selectedUserId),
        selectedCharacterId ? parseInt(selectedCharacterId) : null
      );

      if (response.success) {
        localStorage.setItem('oauth_token', response.token);
        localStorage.setItem('oauth_user', JSON.stringify(response.user));

        await handleOAuthCallback('debug');

        if (onLoginSuccess) {
          onLoginSuccess();
        }
      } else {
        setError(response.message || 'Login failed');
      }
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  const selectedUser = users.find(u => u.id === parseInt(selectedUserId));

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <p>Loading users...</p>
      </div>
    );
  }
  return (
    <div style={{ marginTop: '2rem', padding: '1.5rem', background: 'var(--bg-secondary, #1a1a1a)', borderRadius: '8px', border: '1px solid var(--border, #333)' }}>
      <h3 style={{ marginBottom: '1rem', color: '#ffa500' }}>🔧 Debug Login Mode</h3>
      <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary, #ccc)', marginBottom: '1.5rem' }}>
        Select an OAuth user to login as (Debug mode only)
      </p>
      <form onSubmit={handleSubmit}>
        {error && (
          <div className="admin-error-message" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}
        <div className="admin-form-group">
          <label className="admin-form-label">
            Select User <span className="admin-required">*</span>
          </label>
          <select
            className="admin-form-input"
            value={selectedUserId}
            onChange={(e) => handleUserSelect(e.target.value)}
            required
          >
            <option value="">-- Select User --</option>

            {users.map(user => (
              <option key={user.id} value={user.id}>
                {user.username} {user.roleName ? `(${user.roleName})` : ''}
              </option>
            ))}
          </select>
        </div>
        {selectedUser && selectedUser.characters && selectedUser.characters.length > 0 && (
          <div className="admin-form-group">
            <label className="admin-form-label">Select Character (Optional)</label>
            <select
              className="admin-form-input"
              value={selectedCharacterId}
              onChange={(e) => handleCharacterSelect(e.target.value)}
            >
              <option value="">-- Use Default/First Character --</option>
              {selectedUser.characters.map(character => (
                <option key={character.id} value={character.id}>
                  {character.firstname} {character.lastname} {character.isActive ? '(Active)' : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        <button
          type="submit"
          className="admin-button primary"
          style={{ width: '100%', marginTop: '1rem' }}
          disabled={submitting || !selectedUserId}
        >
          {submitting ? 'Logging in...' : 'Login as Selected User'}
        </button>

      </form>

    </div>

  );
};

export default DebugLogin;

